// src/store/slices/clientEntitySlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

interface WholeGroup {
  isWholeGroup: boolean;
  clientEntityIds:string
}

// const initialState: MonthState = {
//   selectedMonth: dayjs().date() > 15
//     ? dayjs().toISOString()
//     : dayjs().subtract(1, "month").toISOString()
// };
const initialState: WholeGroup = {
  isWholeGroup:false,
  clientEntityIds:""
};

const WholeGroupSlice = createSlice({
  name: 'WholeGroupSlice',
  initialState,
  reducers: {
    setisWholeGroup: (state, action: PayloadAction<boolean>) => {
      state.isWholeGroup = action.payload;
    },
    setallclientEntityIds: (state, action: PayloadAction<string>) => {
      state.clientEntityIds = action.payload;
    },

  },
});

export const { setisWholeGroup, setallclientEntityIds} = WholeGroupSlice.actions;

export default WholeGroupSlice.reducer;
